import { storeToRefs } from 'pinia';
import { NavigationGuard, NavigationHookAfter } from 'vue-router';
import http from '@/store/http';
import { useAccountStore, useLoadingStore } from '@/store';
import { useAuthStore } from '@/plugins';
import NProgress from 'nprogress';
import { clearPage } from 'stepin/es/tabs-view';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false });
const whiteList = ['/login', '/auth-redirect','/sampleCardH5','/signName'];
interface NaviGuard {
  before?: NavigationGuard;
  after?: NavigationHookAfter;
}
// 前置路由守卫
const loginGuard: NavigationGuard = function (to, from,next) {
  console.log(to,'to---------')
  // next()
  NProgress.start()
  // 判断是否有token
  if (getToken()) {
    // to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    
    // 没有token
    if (whiteList.includes(to.path)) {
      
      // 在免登录白名单，直接进入
      next()
    } else {
      // debugger
      next({ path: '/login' })
      // next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      
      NProgress.done()
    }
  }


  // const account = useAccountStore();

  // if (!http.checkAuthorization() && !/^\/(login|home|sampleCardH5)?$/.test(to.fullPath)) {
  //   return '/login';
  //   // account.setLogged(false);
  // }

   //检查是否已登录
  // const isLoggedIn = http.checkAuthorization();
  // const isLoggedIn = false
  //  // 如果已登录且尝试访问登录页，重定向到首页
  // if (isLoggedIn && to.path === '/login') {
  //   return '/home';
  // }
  // // 如果未登录且尝试访问受保护页面，重定向到登录页
  // if (!isLoggedIn && to.path !== '/login') {
  //   return '/login';
  // }
};
// 进度条
const ProgressGuard: NaviGuard = {
  before(to, from) {
    NProgress.start();
  },
  after(to, from) {
    NProgress.done();
  },
};

// const AuthGuard: NaviGuard = {
//   before(to, from) {
//     const { hasAuthority } = useAuthStore();
//     if (to.meta?.permission && !hasAuthority(to.meta?.permission)) {
//       const { authLoading } = storeToRefs(useLoadingStore());
//       return {
//         path: '/403',
//         query: { permission: to.meta.permission, path: to.fullPath, loading: authLoading.value as any },
//       };
//     }
//   },
// };

// 403 forbidden
const ForbiddenGuard: NaviGuard = {
  before(to) {
    const { hasAuthority } = useAuthStore();
    if (to.meta?.permission && !hasAuthority(to.meta?.permission)) {
      const { authLoading } = storeToRefs(useLoadingStore());
      return {
        path: '/403',
        query: { permission: to.meta.permission, path: to.fullPath, loading: authLoading.value as any },
      };
    } else if (to.name === '403' && (to.query.permission || to.query.path)) {
      clearPage(to.query.path as string);
      const { permission, path, loading } = to.query;
      to.params.permission = permission;
      to.params.path = path;
      to.params.loading = loading;
    }
  },
};

// 404 not found
const NotFoundGuard: NaviGuard = {
  before(to, from) {
    const { pageLoading } = useLoadingStore();
    if (to.meta._is404Page && pageLoading) {
      to.params.loading = true as any;
    }
  },
};

export default {
  before: [ProgressGuard.before, ForbiddenGuard.before, loginGuard, NotFoundGuard.before],
  after: [ProgressGuard.after],
};
